import { ComponentChildren } from 'preact';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AnyWidgetSettings } from 'types/settings';

import { ModalsTrackerProvider } from 'components/ModalsTrackerProvider';
import { PortalsManager } from 'components/PortalsManager';
import { SettingsProvider } from 'components/SettingsProvider';

interface AppProviderProps {
  children: ComponentChildren;
  settings: AnyWidgetSettings;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      refetchOnReconnect: false,
    },
  },
});

export function AppProvider({ children, settings }: AppProviderProps) {
  const { settings: commonSettings } = window.wbtxReviewsUtils;

  const customStyles = commonSettings.reviews.general.custom_css;

  const customStylesMarkup =
    customStyles.length > 0 ? <style>{customStyles}</style> : null;

  return (
    <QueryClientProvider client={queryClient}>
      {/* @ts-ignore */}
      <SettingsProvider widgetSettings={settings}>
        <ModalsTrackerProvider>
          <PortalsManager>
            {customStylesMarkup}
            {children}
          </PortalsManager>
        </ModalsTrackerProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
}
